import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en';
import de from './de';

const STORAGE_KEY = 'ss_lang';

function initialLanguage() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'en' || saved === 'de') return saved;
  } catch {
    /* storage unavailable */
  }
  return navigator.language?.startsWith('de') ? 'de' : 'en';
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, de: { translation: de } },
  lng: initialLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnObjects: true,
});

document.documentElement.lang = i18n.language;
i18n.on('languageChanged', (lang) => {
  document.documentElement.lang = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
});

/** Toggles between the two supported UI languages. */
export function toggleLanguage() {
  void i18n.changeLanguage(i18n.language === 'de' ? 'en' : 'de');
}

export default i18n;
